"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
function default_1({ channel_name, }) {
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "text_overflow caption2 gray-80", css: { WebkitLineClamp: 1 } }, { children: channel_name })));
}
exports.default = default_1;
